import Tab, { TabProps } from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import { styled } from '@mui/system'

import tailwind from 'styles/themeTokens'

export const StyledTabs = Tabs

export const StyledTab = styled((props: TabProps) => (
  <Tab disableRipple {...props} />
))(({ theme }) => ({
  textTransform: 'none',
  marginRight: theme.spacing(1),
  color: tailwind.theme.colors.gray[300],
  ':hover': {
    color: theme.palette.primary.main
  }
}))
